import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '@/helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL+'contact/';

class ContactService {

    getList() {
        return axios.get(API_URL + 'getlist/' + UserHelper.getClientId(), { headers: authHeader() });
    }

    create(name, type, contact) {
        return axios.put(API_URL + 'create/' + UserHelper.getClientId(), {
            name: name,
            type: type,
            contact: contact
        },
        { headers: authHeader() });
    }

    delete(contactId) {
        return axios.delete(API_URL + 'delete/' + contactId, { headers: authHeader() });
    }
}

export default new ContactService();